const competitionEvents = () => import("@/views/CompetitionEvents/index.vue");
const competitionHome = () =>
  import("@/views/CompetitionEvents/competitionHome/index.vue");
const competitonZone = () =>
  import("@/views/CompetitionEvents/competitonZone/index.vue");
const competitonPost = () =>
  import("@/views/CompetitionEvents/competitionPost/index.vue");
const competitionNoData = () =>
  import("@/views/CompetitionEvents/competitionNoData/index.vue");
const competitionLiveModal = () =>
  import("@/views/CompetitionEvents/competitionLiveModal/index.vue");

export default {
  path: "/competitionHome",
  redirect: "/competitionHome",
  component: competitionEvents,
  children: [
    // 赛事首页
    {
      name: "competitionHome",
      path: "/competitionHome",
      meta: {
        auth: [1],
        showList: 0,
      },
      component: competitionHome,
    },
    // 赛事专区
    {
      name: "competitionZone",
      path: "/competitionZone",
      meta: {
        auth: [1],
        showList: 0,
      },
      component: competitonZone,
    },
    // 赛事帖子
    {
      name: "competitionPost",
      path: "/competitionPost",
      meta: {
        auth: [1],
        keepAlive: false,
        showList: 0,
        showNav: false,
      },
      component: competitonPost,
    },
    // 赛事直播间
    {
      name: "competitionLiveModal",
      path: "/competitionLiveModal",
      meta: {
        auth: [1],
        showList: 0,
      },
      component: competitionLiveModal,
    },
    // 没有数据
    {
      name: "competitionNoData",
      path: "/competitionNoData",
      meta: {
        auth: [1],
        showList: 0,
      },
      component: competitionNoData,
    },
  ],
};
